import type { FC, ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

import { useAppStore } from '@/store/app'

import { Header } from './Header'
import { LeftSidebarMenuMemo } from './LeftSidebarMenu'

export type LayoutBaseProps = {
  children: ReactNode
  className?: string
}

export const LayoutBase: FC<LayoutBaseProps> = (props) => {
  const { children, className = '' } = props
  const toggleMenu = useAppStore((state) => state.toggleMenu)

  return (
    <>
      <Header />
      <div className={twMerge('container mx-auto flex h-full flex-row px-4 py-5 lg:px-8 lg:py-14', className)}>
        <LeftSidebarMenuMemo />
        <div
          role="button"
          className="overlay"
          tabIndex={0}
          aria-label="Toggle menu"
          onKeyDown={() => {}}
          onClick={() => toggleMenu()}
        />
        <main className="flex-auto">{children}</main>
      </div>
    </>
  )
}
